module.exports = __webpack_public_path__ + "static/media/ren.33da89b0.svg";